<template>
  <div>
    <img src="../assets/homeLogo.png" class="logoImg" />
    <div class="userName">{{userInfo_name}}</div>
    <div class="flexBox">
      <router-link :to="{path:'/customer'}" class="linkList">
        <div class="list">
          <img src="../assets/home/address-card.png" />
          <div>我的经销商</div>
        </div>
      </router-link>
      <router-link :to="{path:'/outScan'}" class="linkList">
        <div class="list">
          <img src="../assets/home/barcode-scan.png" />
          <div>出库采集</div>
        </div>
      </router-link>
      <router-link :to="{path:'/outRecord/RecordIndex'}" class="linkList">
        <div class="list">
          <img src="../assets/home/box1.png" />
          <div>出库记录</div>
        </div>
      </router-link>
      <router-link :to="{path:'/backScan'}" class="linkList">
        <div class="list">
          <img src="../assets/home/arrows.png" />
          <div>退货采集</div>
        </div>
      </router-link>
      <router-link :to="{path:'/backRecord/RecordIndex'}" class="linkList">
        <div class="list">
          <img src="../assets/home/box.png" />
          <div>退货记录</div>
        </div>
      </router-link>
       <router-link :to="{path:'/ChangePass'}" class="linkList">
        <div class="list">
          <img src="../assets/changepass.png" />
          <div>修改密码</div>
        </div>
      </router-link>
    </div>
    <div class="exitBtn" @click="exitOut()">退出</div>
  </div>
</template>

<script>
// @ is an alias to /src
import { Button } from "vant";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      titName: "首页",
    };
  },
  components: {
    [Button.name]: Button,
  },
  methods: {
    exitOut() {
      sessionStorage.removeItem("ticket");
      this.$router.push({
        path: "/login",
      });
    },
    buy(e) {
      this.$store.dispatch("buyVip", e);
    },
  },
  computed: {
    ...mapGetters(["userInfo_name"]),
  },
};
</script>
<style scoped>
.userName {
  font-size: 24px;
}
.logoImg {
  width: 160px;
  display: block;
  margin: 50px auto;
  box-shadow: 0 0 10px 0 #eee;
  border-radius: 50%;
}
.flexBox {
  display: flex;
  align-items: center;
  margin-top: 60px;
  flex-wrap: wrap;
}
.linkList {
  width: 33.3%;
  margin-bottom: 30px;
  box-shadow: 0 0 2px 0 #eee;
  padding: 10px 0;
}
.list {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 10px;
  color: #666666;
}
.list img {
  width: 46px;
}
.list div {
  width: 100%;
}
.exitBtn {
  width: 200px;
  margin: 0 auto;
  background: #e62129;
  color: white;
  font-size: 16px;
  border-radius: 5px;
  line-height: 36px;
  height: 36px;
  margin-top: 20px;
}
</style>
